export default {
  API_PREFIX: '/api',
  PUBLIC_PATH: '',
  DEFAULT_URL: '/',
  PING_INTERVAL: 30000,
  CHECK_PAYMENT_STATUS: 3000,
  CHECK_PAYMENT_STATUS_BACKGROUND: 7000,
  REQUEST_ITEMS_LIMIT: 20,
};
